"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hunPlace = exports.place = exports.hunPostCode = exports.postCode = exports.hunCounty = exports.county = exports.country = exports.hunPlaceToPostCode = exports.hunPostCodeToPlace = exports.hunPlaces = exports.hunPostCodes = exports.hunCounties = exports.hunCountryCode = exports.countryCodes = void 0;
const i18n_iso_countries_1 = require("i18n-iso-countries");
const schema_1 = require("../schema");
const location_json_1 = __importDefault(require("./location.json"));
exports.countryCodes = new Map(Object.entries((0, i18n_iso_countries_1.getAlpha3Codes)()));
exports.hunCountryCode = "HUN";
exports.hunCounties = [
    "Bács-Kiskun",
    "Baranya",
    "Békés",
    "Borsod-Abaúj-Zemplén",
    "Budapest",
    "Csongrád-Csanád",
    "Fejér",
    "Győr-Moson-Sopron",
    "Hajdú-Bihar",
    "Heves",
    "Jász-Nagykun-Szolnok",
    "Komárom-Esztergom",
    "Nógrád",
    "Pest",
    "Somogy",
    "Szabolcs-Szatmár-Bereg",
    "Tolna",
    "Vas",
    "Veszprém",
    "Zala"
];
exports.hunPostCodes = [];
exports.hunPlaces = [];
exports.hunPostCodeToPlace = new Map();
exports.hunPlaceToPostCode = new Map();
for (const { postCode, name } of location_json_1.default) {
    exports.hunPostCodes.push(postCode);
    exports.hunPlaces.push(name);
    exports.hunPostCodeToPlace.set(postCode, name);
    exports.hunPlaceToPostCode.set(name, postCode);
}
exports.country = schema_1.Schema.custom(key => exports.countryCodes.has(key), {
    value: "country"
}).default(exports.hunCountryCode);
exports.county = schema_1.Schema.string();
exports.hunCounty = schema_1.Schema.custom(value => exports.hunCounties.includes(value), {
    value: "hunCounty"
});
exports.postCode = schema_1.Schema.string();
exports.hunPostCode = schema_1.Schema.custom(key => exports.hunPostCodeToPlace.has(key), {
    value: "hunPostCode"
});
exports.place = schema_1.Schema.string();
exports.hunPlace = schema_1.Schema.custom(key => exports.hunPlaceToPostCode.has(key), {
    value: "hunPlace"
});
